<template>
  <div class="search_container searchArea">
        <el-form 
            :inline="true" 
            :model='search_data' 
            :rules="rules"
            ref="search_data" 
            class="demo-form-inline search-form">
            <el-form-item label="">
                <!-- <el-input v-model·="search_data.telephoneNumber" placeholder="手机号"  @keyup.enter.native='onScreeoutMoney("search_data")'></el-input> -->
            </el-form-item>
            <el-form-item>
                <!-- <el-button type="primary" size ="mini" icon="search" @click='onScreeoutMoney("search_data")'>筛选</el-button> -->
            </el-form-item>

            <el-form-item class="btnRight">
                <!-- <el-button type="primary" size ="mini" icon="view" @click='onAddCoursePackage()'>添加</el-button> -->
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
   import { mapGetters } from 'vuex'

  export default {
      name:'searchItem',
      data(){
          return {
            search_data:{
            },
            rules: {
                name: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                ]
            }
          }
      },
       computed:{
        ...mapGetters(['courseSearchBtnDisabled']),
      },
      created(){
      },
      methods:{
          onAddCoursePackage(){
              this.$emit("showDialog",'add');
          }
      }
  }
</script>

<style lang="less" scoped>
    .search_container{
        margin-bottom: 20px;
    }
    .btnRight{
        float: right;
        margin-right: 0px !important;
    }
    .searchArea{
        background:rgba(255,255,255,1);
        border-radius:2px;
        padding: 18px 18px 0;
    }
</style>
